






import { Component, Vue } from 'vue-property-decorator'
import { CustomerManagementState } from '../store'

@Component({
  components: {
  }
})
export default class ManagementPage extends Vue {
  public mounted () {

  }

  public created () {
  }

  public activated () {
  }

  public updated () {
  }

  public destroyed () {
  }

  public deactivated () {

  }
}
